export enum FtuePreference {
  FEMALE = "Female",
  MALE = "Male",
  NON_BINARY = "Non-Binary",
}

export type FtueModalProps = {
  dataTestId?: string;
  onConfirmation: (selectedPreferences: FtuePreference[]) => void;
};
